/*
  RK: DE FOTO IN DE WINKELWAGEN VOORUIT OPHALEN.

  ============================================================
  WAT WAS HET PROBLEEM
  ============================================================
  Klik je op ADD TO CART, dan rendert Shopify de hele winkelwagen-lade
  opnieuw op de server en zet die verse HTML in de pagina. Gemeten in de
  winkel (Ronaldinho, 29-10):

    0 ms     klik op ADD
    925 ms   de nieuwe HTML van de lade staat in de pagina
    1621 ms  de foto van het artikel staat er

  Tussen die twee stond er een leeg vakje. Niet omdat de foto zwaar is -
  die is 3 KB en is in 1 ms binnen - maar omdat de AANVRAAG pas om 925 ms
  begint en de CDN er 388 ms over doet om te antwoorden (TTFB). De lade
  vraagt de foto namelijk op in width=160 / width=320, en die maat komt
  nergens anders op de pagina voor, dus die URL zit nog niet in de cache.

  ============================================================
  WAT DIT BESTAND DOET
  ============================================================
  Op het moment dat je op een toevoegen-knop klikt (de knop op de
  productpagina, het plusje in "vaak samen gekocht", of de knop in de
  snelbekijk-lade) vraagt dit bestand diezelfde foto al op in precies de
  twee maten die de lade straks gebruikt. Dat kost 3 KB en gebeurt
  parallel met het toevoegen zelf, dus het vertraagt niets - en als de
  lade 900 ms later in beeld komt, staat de foto al in de cache en is hij
  er meteen.

  Mist hij de juiste foto (bijvoorbeeld bij een variant met een eigen
  foto die nog niet in beeld stond), dan is er niets stuk: dan laadt de
  lade hem gewoon zoals eerst. Een misser kost 3 KB.

  Dit bestand raakt de winkelwagen zelf niet aan: het leest alleen
  fotolinkjes en zet er Image()-aanvragen op. Niets in assets/cart.js,
  assets/cart-drawer.js of assets/rk-cart-drawer.js hoeft hiervan te
  weten.

  ============================================================
  EN DE TEGELS VAN "VAAK SAMEN GEKOCHT"
  ============================================================
  Die hingen aan hetzelfde euvel, maar dan erger. Gemeten op
  /collections/all met drie artikelen in de wagen en de lade DICHT, vijf
  seconden na het laden:

    de drie artikelfoto's   loading=eager   al binnen
    de elf tegels           loading=lazy    geen enkel verzoek gedaan

  Een foto die lazy staat en in een lade staat die buiten beeld hangt,
  haalt de browser pas op zodra die lade opengaat. Alle elf tegels
  begonnen dus pas te laden op het moment dat de klant op het
  winkelwagentje tikte - en dan zie je ze een voor een inploppen.

  De eerste vier tegels (dat is wat je ziet plus een halve veeg) halen we
  daarom alvast op, met lage prioriteit: ze mogen nooit voorkruipen op de
  foto's van de pagina zelf. De rest blijft lazy en komt vanzelf als er
  geveegd wordt.

  Dit kost alleen iets bij iemand die al iets in zijn wagen heeft - zonder
  artikelen is er namelijk geen upsell-blok.

  ============================================================
  !! WAAROM MET new Image() EN NIET DOOR loading TE VERZETTEN !!
  ============================================================
  Eerst stond hier alleen img.loading = 'eager'. Dat werkt in Chrome, maar
  NIET in Safari: WebKit kijkt niet opnieuw naar een foto die al als lazy
  is ingelezen. Op een iPhone deed deze hele functie dus niets en bleef de
  lade even traag - en 95% van de bestellingen komt van mobiel.

  Een echte aanvraag via new Image() hoeft niemand slim op te pakken: de
  browser haalt hem op, zet hem in zijn cache, en als de lade opengaat
  staat diezelfde URL er meteen. Het attribuut zetten we er daarnaast nog
  wel op, voor de browsers die het wel oppakken - maar niets hangt er meer
  van af.

  De foto's van de ARTIKELEN staan niet meer in dit bestand: die krijgen
  hun eager/fetchpriority gewoon in snippets/cart-drawer.liquid mee, dus
  daar hoeft helemaal geen JavaScript meer aan te pas te komen.

  ============================================================
  LET OP BIJ WIJZIGEN
  ============================================================
  De twee maten hieronder moeten GELIJK BLIJVEN aan de maten in de
  srcset van het artikel in snippets/cart-drawer.liquid (nu 160 en 320).
  Zet je die daar anders, dan warmt dit bestand de verkeerde URL op en
  is het stil nutteloos - geen foutmelding, alleen weer een leeg vakje.
*/
(function () {
  'use strict';

  /* Gelijkhouden met de srcset in snippets/cart-drawer.liquid. */
  var WIDTHS = [160, 320];

  /* De knoppen waarna de lade met een nieuw artikel verschijnt. */
  var ADD = 'button[name="add"], .rk-up__add, .rk-qv__add, [data-rk-qv-add]';

  /* Het blok waar de bijbehorende foto in staat. Van klein naar groot:
     eerst de tegel of de snelbekijk-lade, dan pas de productpagina. */
  var SCOPES = '.rk-up__item, [data-rk-quickview], .product, main';

  var warmed = {};

  function isShopifyImage(src) {
    return !!src && (src.indexOf('/cdn/shop/') > -1 || src.indexOf('cdn.shopify.com') > -1);
  }

  /* Maakt van een willekeurige Shopify-fotolink dezelfde link in de maat
     die de winkelwagen gebruikt. Het oude _600x600-achtige stukje in de
     bestandsnaam moet eruit, anders stapelen de maten op elkaar. */
  function cartSizedUrls(src) {
    var out = [];
    try {
      var base = new URL(src, window.location.href);
      base.pathname = base.pathname.replace(/_(\d+)x(\d+)?(_crop_[a-z]+)?(@\dx)?(?=\.[a-zA-Z0-9]+$)/, '');
      base.searchParams.delete('height');
      for (var i = 0; i < WIDTHS.length; i++) {
        var u = new URL(base.href);
        u.searchParams.set('width', String(WIDTHS[i]));
        out.push(u.href);
      }
    } catch (e) {
      /* Een rare link is geen reden om de klik te laten mislukken. */
    }
    return out;
  }

  function warm(src) {
    cartSizedUrls(src).forEach(function (href) {
      if (warmed[href]) return;
      warmed[href] = true;
      var img = new Image();
      try {
        img.fetchPriority = 'high';
      } catch (e) {}
      img.decoding = 'async';
      img.src = href;
    });
  }

  /* De foto's die de klant op dit moment ECHT ziet. Een productpagina
     heeft een hele rij dia's in de HTML staan; alleen de dia die in
     beeld staat hoort bij de variant die hij aan het toevoegen is. */
  function visibleImages(scope) {
    var all = Array.prototype.slice.call(scope.querySelectorAll('img'));
    var shown = all.filter(function (img) {
      if (!isShopifyImage(img.currentSrc || img.getAttribute('src'))) return false;
      if (!img.offsetParent && img.style.position !== 'fixed') return false;
      var r = img.getBoundingClientRect();
      if (r.width < 40 || r.height < 40) return false;
      return r.bottom > 0 && r.top < (window.innerHeight || 0) + 200;
    });
    var pick = shown.length ? shown : all.filter(function (img) {
      return isShopifyImage(img.currentSrc || img.getAttribute('src'));
    });
    return pick.slice(0, 2);
  }

  document.addEventListener(
    'click',
    function (event) {
      var target = event.target;
      if (!target || !target.closest) return;
      var button = target.closest(ADD);
      if (!button) return;
      var scope = button.closest(SCOPES) || document.body;
      visibleImages(scope).forEach(function (img) {
        warm(img.currentSrc || img.getAttribute('src'));
      });
    },
    true
  );

  /* Hoeveel tegels van "vaak samen gekocht" vooruit geladen worden. Drie
     staan er in beeld; de vierde vangt de eerste veeg op. */
  var TILES_AHEAD = 4;

  /* Welke van de twee maten uit de srcset gaat deze telefoon ophalen? Die
     en alleen die halen we vooruit op; de andere zou een tweede, nutteloos
     verzoek zijn. Staat er geen srcset, dan is src het antwoord. */
  function pickFromSrcset(img) {
    var set = img.getAttribute('srcset') || '';
    var dpr = window.devicePixelRatio || 1;
    var best = '';
    var bestX = 0;
    set.split(',').forEach(function (part) {
      var bits = part.trim().split(/\s+/);
      if (!bits[0]) return;
      var x = parseFloat(bits[1]) || 1;
      /* de kleinste die nog groot genoeg is, anders de grootste die er is */
      if (!best || (bestX < dpr && x > bestX) || (x >= dpr && x < bestX)) {
        best = bits[0];
        bestX = x;
      }
    });
    return best || img.getAttribute('src') || '';
  }

  /* De eerste tegels alvast ophalen - laag in de rij, zodat de pagina zelf
     altijd voorgaat. Dit mag meerdere keren draaien: hij kijkt steeds naar
     dezelfde eerste vier kaarten en elke URL gaat maar een keer de deur
     uit (zie warmed). */
  function warmTiles() {
    var cards = document.querySelectorAll('.rk-up__card');
    var n = Math.min(cards.length, TILES_AHEAD);
    for (var i = 0; i < n; i++) {
      var img = cards[i].querySelector('img');
      if (!img) continue;

      /* DE ECHTE AANVRAAG - zie de kop over Safari. */
      var href = pickFromSrcset(img);
      if (href && !warmed[href]) {
        warmed[href] = true;
        var pre = new Image();
        try {
          pre.fetchPriority = 'low';
        } catch (e) {}
        pre.decoding = 'async';
        pre.src = href;
      }

      /* En voor de browsers die het wel oppakken ook het attribuut, zodat
         de tegel niet alsnog op het openen van de lade gaat wachten. */
      if (img.getAttribute('loading') === 'lazy') {
        try {
          img.fetchPriority = 'low';
        } catch (e) {}
        img.loading = 'eager';
      }
    }
  }

  /*
    ZODRA DE TEGELS ER ZIJN, NIET LATER.

    Hier stond eerst "pas op een rustig moment na het laden van de pagina":
    requestIdleCallback na het load-event. Gemeten op een collectiepagina met
    iets in de wagen:

      980 ms   DOMContentLoaded
     1136 ms   load
     1307 ms   de aanbevelingen worden opgehaald
     1521 ms   ze zijn binnen, de tegels staan in de pagina
     1722 ms   PAS HIER begonnen de foto's  (de rustige-moment-wachttijd)
     1972 ms   ze stonden er

    Die laatste 200 ms is zonde: op het moment dat de tegels bestaan is de
    pagina zelf allang geladen. Dus nu meteen, met lage prioriteit - dan
    kruipen ze nog steeds niet voor op wat de klant op dat moment bekijkt,
    maar ze staan wel eerder klaar als hij de wagen opent.

    De vlag hoort erbij: de waarnemer hieronder gaat bij ELKE wijziging in
    de lade af, en zonder vlag stonden er zo twintig dezelfde taken in de
    rij te wachten. Eentje tegelijk is genoeg - warmTiles kijkt toch altijd
    naar dezelfde eerste vier kaarten.

    !! EEN GEWONE setTimeout, GEEN requestAnimationFrame EN GEEN
       requestIdleCallback - DIT IS EEN GEMETEN FOUT !!
    Met requestAnimationFrame deed dit bestand in de test helemaal niets:
    nul verzoeken, de tegels bleven op lazy staan. Een browser laat die
    twee functies namelijk NIET afgaan zolang het tabblad op de achtergrond
    staat, en dat is precies wat er gebeurt zodra iemand even van app
    wisselt. De vlag bleef daardoor op true hangen en elke volgende poging
    liep er stil op stuk - een klem die zichzelf nooit meer losmaakt.

    setTimeout loopt wel door op de achtergrond (hooguit vertraagd), dus
    de vlag komt altijd weer vrij.
  */
  var queued = false;

  function soon(fn) {
    if (queued) return;
    queued = true;
    window.setTimeout(function () {
      queued = false;
      fn();
    }, 0);
  }

  function start() {
    soon(warmTiles);

    /* De tegels komen uit JavaScript en de lade wordt na elke plus/min
       opnieuw neergezet, dus ze verschijnen later alsnog. */
    new MutationObserver(function (records) {
      for (var i = 0; i < records.length; i++) {
        if (records[i].addedNodes.length) {
          soon(warmTiles);
          return;
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();